import * as http from "@/api/config";

/* 获取角色列表 */
export function getSysRoleList(data) {
    const url = "sysyem/admin/v1/role/list";
    return http.$get(url, data);
}

/* 获取角色详情 */
export function getSysRoleInfo(uuid) {
    const url = `sysyem/admin/v1/role/info/${uuid}`;
    return http.$get(url);
}

/* 创建后台角色 */
export function createSysRole(data) {
    const url = "sysyem/admin/v1/role/create";
    return http.$post(url, data);
}

/* 编辑角色 */
export function updateSysRole(uuid, data) {
    const url = `sysyem/admin/v1/role/update/${uuid}`;
    return http.$put(url, data);
}

/* 删除角色 */
export function deleteSycRole(uuid) {
    const url = `sysyem/admin/v1/role/delete/${uuid}`;
    return http.$delete(url);
}

/* 角色关联权限 */
export function roleBindSycRight(uuid, data) {
    const url = `sysyem/admin/v1/role/bindRight/${uuid}`;
    return http.$post(url, data);
}

/* 角色下增加用户 */
export function userBindSycRole(uuid, data) {
    const url = `sysyem/admin/v1/role/bindUser/${uuid}`;
    return http.$post(url, data);
}

/* 获取系统权限 */
export function getSysRightList(data) {
    const url = "sysyem/admin/v1/right/list";
    return http.$get(url, data);
}

/* 创建系统权限 */
export function createSysRight(data) {
    const url = "sysyem/admin/v1/right/create";
    return http.$post(url, data);
}

/* 编辑系统权限 */
export function updateSysRight(action, data) {
    const url = `sysyem/admin/v1/right/update/${action}`;
    return http.$put(url, data);
}


/* 删除系统权限 */
export function deleteSysRight($action) {
    const url = `sysyem/admin/v1/right/delete/${action}`;
    return http.$delete(url, data); 
}


// WEBPACK FOOTER //
// ./src/api/module/role.js